import { usePage } from '@inertiajs/vue3';

export function debounce(fn, wait) {
    let timer;
    return function(...args) {
        if (timer) {
            clearTimeout(timer); // clear any pre-existing timer
        }
        const context = this; // get the current context
        timer = setTimeout(() => {
            fn.apply(context, args); // call the function if time expires
        }, wait);
    };
}

export function hasPermission (permission) {
    const page = usePage();

    if (! page.props.auth) {
        return false;
    }

    if ('string' === typeof permission) {
        return page.props.permissions.includes(permission);
    }

    return page.props.permissions.some(p => permission.includes(p));
}
